import type { UIAnalyticsEvent } from '@atlaskit/analytics-next';
import type { FetchError } from '@atlassian/help-center-common-util/fetch';
import type { ApolloErrorResponse, ErrorResponse } from 'epics/model/types';

interface ErrorWithNestedResponse {
	response?: ApolloErrorResponse;
}

const getErrorMessage = (
	error: Error | ApolloErrorResponse | ErrorResponse,
): string | undefined => {
	const nestedResponse = (error as ErrorWithNestedResponse).response;

	return (
		nestedResponse?.errorMessage ||
		(error as ApolloErrorResponse).errorMessage ||
		(error as ErrorResponse).errorMessages?.join(',') ||
		(error as Error).message
	);
};

const getErrorStatus = (error: Error | ApolloErrorResponse | ErrorResponse): number | undefined => {
	const nestedResponse = (error as ErrorWithNestedResponse).response;

	return (
		(error as FetchError).status ||
		nestedResponse?.statusCode ||
		(error as ApolloErrorResponse).statusCode
	);
};

export const logErrorToFailureEvent = (
	analyticsFailureEvent: UIAnalyticsEvent,
	error: Error | ApolloErrorResponse | ErrorResponse,
) => {
	analyticsFailureEvent.update((payload: UIAnalyticsEvent) => ({
		...payload,
		errorMessage: getErrorMessage(error),
		status: getErrorStatus(error),
	}));
	return analyticsFailureEvent;
};
